import script from "./review.vue?vue&type=script&setup=true&lang=js"
export * from "./review.vue?vue&type=script&setup=true&lang=js"

import "./review.vue?vue&type=style&index=0&id=85c85722&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85c85722"]])

export default __exports__